import { useLocale } from "@lib/i18n/navigation-pages-router";
import { defaultLocale } from "@lib/i18n/config";
import { useCurrentUser } from "@hooks/use-current-user";
import Image from "@components/core/Image";
import staticSitesEntryPoint from "@utils/constants/staticSitesEntryPoint";
import Navbar from "./Navbar/Navbar";

function HeaderAuth() {
  const locale = useLocale();
  const user = useCurrentUser();

  const homeUrl = user
    ? `${locale !== defaultLocale ? `/${locale}` : ""}/home`
    : `${process.env.NEXT_PUBLIC_CUSTOMER_WEBSITE}${staticSitesEntryPoint[locale]}`;

  return (
    <header className="sticky-top">
      <Navbar className="navbar-logo-only">
        <a href={homeUrl}>
          <Image
            src="logo"
            alt="logo"
            style={{ height: "24px" }}
          />
        </a>
      </Navbar>
    </header>
  );
}

export default HeaderAuth;
